import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "@/lib/api";
import QuoteForm from "@/components/QuoteForm";
import { ArrowLeft, Clock, Loader2 } from "lucide-react";

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPost(null);
    setNotFound(false);
    api
      .get(`/posts/${slug}`)
      .then(({ data }) => {
        setPost(data);
        document.title = `${data.title} · Fast Junk Pros`;
      })
      .catch(() => setNotFound(true));
    return () => {
      document.title = "Fast Junk Pros";
    };
  }, [slug]);

  if (notFound) {
    return (
      <div className="container-wide py-20 text-center" data-testid="post-not-found">
        <h1 className="font-display text-3xl font-black">Article not found</h1>
        <Link to="/blog" className="btn-cta mt-6"><ArrowLeft className="h-4 w-4" /> Back to blog</Link>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="flex items-center justify-center py-20 text-muted-foreground">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }

  const published = new Date(post.published_at).toLocaleDateString(undefined, {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div data-testid={`post-${post.slug}`}>
      <section className="border-b border-border bg-muted">
        <div className="container-wide py-16 lg:py-20">
          <Link to="/blog" className="inline-flex items-center gap-1 text-sm font-semibold text-primary hover:underline">
            <ArrowLeft className="h-4 w-4" /> All articles
          </Link>
          <h1 className="mt-6 font-display text-4xl font-black leading-tight sm:text-5xl lg:text-6xl">{post.title}</h1>
          <div className="mt-5 flex items-center gap-4 text-sm text-muted-foreground">
            <span>{published}</span>
            <span className="flex items-center gap-1"><Clock className="h-3.5 w-3.5" /> {post.read_minutes} min read</span>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-wide grid gap-10 lg:grid-cols-5">
          <article
            className="prose-td lg:col-span-3"
            data-testid="post-body"
            dangerouslySetInnerHTML={{ __html: post.body_html }}
          />
          <aside className="lg:col-span-2">
            <div className="sticky top-24">
              <div className="rounded-sm border border-border bg-card p-6">
                <p className="kicker">Free Quote</p>
                <h3 className="mt-2 font-display text-xl font-bold">Need it hauled?</h3>
                <p className="mt-2 text-sm text-muted-foreground">
                  Get an upfront price in about a minute.
                </p>
                <div className="mt-4">
                  <QuoteForm />
                </div>
              </div>
            </div>
          </aside>
        </div>
      </section>
    </div>
  );
};

export default BlogPost;
